// extracted by mini-css-extract-plugin
var _1 = "kVsrPoVqXRCJMG9gS7lR";
export { _1 as "summaryCellButton" }
export default { "summaryCellButton": _1 }
